module.exports = __webpack_public_path__ + "97ec2a87c8c574c316bd54a5fafb70bc.png";